export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/esm/components/core/translate/maxTranslate.js
// module id = null
// module chunks = 